import React from 'react';

import cn from 'classnames';
import Image from 'next/legacy/image';
import { NextRouter } from 'next/router';

import { COMMUNITY_PATHS } from '@constants/index';
import { Button } from '@element/index'
import { I18n } from '@utils/index';

import { openModalBg } from './ModalBg';

import styles from './index.module.less';

interface ContentProps {
  /** 关闭弹窗 */
  closeModal: () => void;
  router: NextRouter;
  name: string;
}

const Content: React.FC<ContentProps> = (props) => {
  const { router, closeModal, name = '' } = props;
  const handleGoCommunity = () => {
    router?.push({ pathname: COMMUNITY_PATHS.COMMUNITY });
    closeModal();
  }

  return (
    <div className={styles.lottieWrapper}>
      <div className={styles.header}>
        <div className={styles.title}>{I18n.t('5f1P4lZY', { name })}</div>
        <div className={styles.desc}>{I18n.t('B3vxoklO')}</div>
      </div>
      <div className={cn(styles.boxWrapper, styles.marginWrapper)}>
        <div className={styles.boxImg}>
          <Image src={require('@images/airdrop/question.webp')} alt="kikitrade" />
        </div>
      </div>
      <div className={styles.btnWrapper}>
        <Button
          type='ghost'
          className={cn(styles.btnItem, styles.cancel)}
          data-buried="overdue-know-btn"
          onClick={closeModal}
        >
          {I18n.t('IKnow')}
        </Button>
        <Button
          type='primary'
          className={cn(styles.btnItem, styles.primary)}
          data-buried="overdue-go-community"
          onClick={handleGoCommunity}
        >
          {I18n.t('SwTa52Jn')}
        </Button>
      </div>
    </div>
  );
}

interface IOpenModalBgParams extends Pick<ContentProps, 'router' | 'name'> {
  el: HTMLElement;
}

export const openOverdueModal = ({ el, ...rest }: IOpenModalBgParams) => {
  return openModalBg({
    el,
    children: (params) => <Content {...rest} closeModal={params.removePreview} />
  })
}
